var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 40 29",
        "enable-background": "new 0 0 40 29",
        "xml:space": "preserve"
      }
    },
    [
      _c(
        "linearGradient",
        {
          attrs: {
            id: "brandGradient",
            gradientUnits: "userSpaceOnUse",
            x1: "-1829.2997",
            y1: "38.4395",
            x2: "-1830.2896",
            y2: "38.4395",
            gradientTransform:
              "matrix(-39.3625 0 0 -27.6775 -72005.4219 1078.658)"
          }
        },
        [
          _vm.theme === "truck"
            ? [
                _c("stop", {
                  staticStyle: { "stop-color": "#2B9955" },
                  attrs: { offset: "0" }
                }),
                _vm._v(" "),
                _c("stop", {
                  staticStyle: { "stop-color": "#0D92CD" },
                  attrs: { offset: "1" }
                })
              ]
            : _vm.theme === "academy"
            ? [
                _c("stop", {
                  staticStyle: { "stop-color": "#E3001D" },
                  attrs: { offset: "0" }
                }),
                _vm._v(" "),
                _c("stop", {
                  staticStyle: { "stop-color": "#FECE42" },
                  attrs: { offset: "1" }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "url(#brandGradient)",
          d:
            "M12.9,28.2c0.5,0.6,1.4,0.6,2,0c0.5-0.5,0.5-1.4,0-2L4.8,16.1H38c0.8,0,1.4-0.6,1.4-1.4\n\tc0-0.8-0.6-1.4-1.4-1.4H4.7l10.1-10c0.5-0.6,0.5-1.4,0-2c-0.6-0.6-1.4-0.6-2,0L0.4,13.7c-0.6,0.5-0.6,1.4,0,2L12.9,28.2z"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }